import styled from '@emotion/styled'

/**
 * SiGunGuGroup — 시군구 단위 그룹 (헤더 + 카드 N개).
 *
 * 디자인:
 *  - 헤더 ("고양시"): Title 18 Bold, padding 좌우 4px
 *  - 헤더 ↔ 카드 그룹 사이 8px gap
 *  - 그룹 간 (= 다음 시군구) 사이 20px gap → 부모 컨테이너의 gap이 처리
 */

/**
 * 자동 스크롤 시 sticky Tabs 와 시군구 타이틀 사이 gap.
 *
 * scroll-margin-top = sticky Tabs 높이(48px) + 하단 border 1px + 시각적 호흡 20px.
 * scrollIntoView({ block: 'start' }) 와 함께 사용 — Wrapper 의 top 이 viewport top + 이 값에 위치.
 *
 * Tabs height(48px) 변경 시 동기 — components/Tabs/styles.ts 의 Tab.height 와 매칭.
 */
const STICKY_TABS_HEIGHT_PX = 49 // Tab 48 + border-bottom 1
const SCROLL_GAP_PX = 20
const SCROLL_MARGIN_TOP_PX = STICKY_TABS_HEIGHT_PX + SCROLL_GAP_PX

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  scroll-margin-top: ${SCROLL_MARGIN_TOP_PX}px;
`

export const Title = styled.h3`
  display: inline-flex;
  align-items: center;
  margin: 0;
  padding: 0 4px;
  font-size: 18px;
  font-weight: 700;
  line-height: 26px;
  letter-spacing: -0.18px;
  color: #1b1c1d;
`

export const CardList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`
